<template>
  <div>
    <div v-if="detail">
      <div class="bl-detail-block bg-white">
        <div class="bl-container">
          <div class="bl-detail-left">
            <div class="v-person-info">
              <div class="v-person-m">
                <div class="v-avatar" style="width: 100px;height: 100px;"
                  :style="{ backgroundImage: `url(${detail.logoImage})` }"></div>
              </div>
              <div class="v-person-b">
                <div class="v-person-body">
                  <span class="v-person-name ellipsis"><b>{{ (detailsInfo.name && detailsInfo.name.content) ||
                      detail.name }}</b></span>
                  <template v-if="$store.state.config.hideElement">
                    <div class="v-pointer v-person-collect" @click="collectEvent2">
                      <span class="iconfont theme-icon-primary-color"
                        :class="{ 'iconshoucang-xuanzhong': detail['collected'], iconshoucang: !detail['collected'] }"></span>
                      <span>{{ detail['collected'] ? $t('collect[1]') : $t('collect[0]') }}</span>
                    </div>
                    <div class="color-black-45 v-person-view2">
                      <i class="el-icon-view theme-icon-primary-color" style="font-weight: bold"></i><span>{{detail.pageView }}</span>
                    </div>
                  </template>
                  <div class="v-pointer v-person-collect" style="margin-left: 8px;" @click="handleShowDialog(detail)">
                    <span class="iconfont theme-icon-primary-color iconhuifu"></span>
                    <span>{{ $t('message') }}</span>
                  </div>
                </div>
                <div class="v-exhibitor-data v-clearfix">
                  <span class="c65">{{ $t('finds.Booth') }}：<font class="c65 f-w-b">{{ detail.exhibitionBoothNumber }}
                    </font></span>
                  <div class="v-person-info2" style="display: block; width: 100%">
                    <template v-if="hList.length > 0">
                      <span v-for="item in hList[0].answerList" :key="item.id" class="bg-light5 theme-color ques-label">
                        {{ language == 'zh' ? item.aliasName : item.aliasEnName }}
                      </span>
                    </template>
                    <!-- <span class="theme-color pointer color-live" v-if="detail['liveState']" @click="live2(detail)"
                      ><span class="iconfont iconzhibo"></span
                      >{{liveStatusText(detail.live)}}</span> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="v-detail-left" v-if="swiperOption.list.length !== 0">
              <div class="img-box v-img pointer v--video-img">
                <div class="text-center" style="height: 100%"
                  v-if="detail && detail.advertsVideo && firstImg && firstImg.length > 1" @click="openVideo">
                  <img :src="firstImg[0]" alt="" />
                  <span class="icon-video"></span>
                </div>
                <template v-if="firstImg && firstImg.length == 1">
                  <el-image style="height: 100%;width:100%" :src="firstImg[0]" :preview-src-list="viewList"> </el-image>
                </template>
              </div>
              <v-swiper @callback="cb" :option="swiperOption" class="v-swiper"></v-swiper>
            </div>

            <!-- <hr style="margin: 24px 0; opacity: .2" /> -->

            <div class="v-title">{{ $t('baseMess') }}</div>
            <el-row :gutter="30">
              <template v-for="(item, index) in detail.details">
                <el-col :span="12" :key="index"
                  v-if="noShowData.indexOf(item['keyword']) == -1 && item['showValue']['content']">
                  <div class="v-color">
                    <span>{{ item['showValue']['title'] }}：</span><span>
                      <template v-if="item['showValue']['title'] === '是否上市'">
                        {{ item['showValue']['content'] === true ? $t('Yes') : $t('No') }}
                      </template>
                      <template v-else>
                        <template v-if="item['keyword'] == 'webUrl' || item['keyword'] == 'url3d'">
                          <span v-if="item['keyword'] == 'webUrl' && item['showValue']['content']">
                            <a :href="item['showValue']['content']" target="view_window">{{ $t('finds.enterDetail') }}
                            </a>
                          </span>
                          <span v-else-if="item['keyword'] == 'url3d'">
                            <a :href="item['showValue']['content']" target="view_window"> {{ $t('finds.enterDetail') }}
                            </a>
                          </span>
                        </template>
                        <template v-else>
                          <span>{{ item['showValue']['content'] }}</span>
                        </template>
                      </template>
                    </span>
                  </div>
                </el-col>
              </template>
            </el-row>

            <div style="margin: 6px 0">
              <template v-if="detail.questionList">
                <div class="detail-questionTag" v-for="item in detail.questionList" :key="item.id">
                  <template v-if="item.id != '4df3de85c5d039c265fe4d91bfeaad70'">
                    <span class="font-size-14">{{ item.aliasName }}：</span>
                    <label v-for="aItem in item.answerList" :key="aItem.id" class="bg-light5">{{ aItem.aliasName
                      }}</label>
                  </template>
                </div>
              </template>
            </div>

            <!-- <hr style="margin: 24px 0; opacity: .2" /> -->

            <div class="v-title">{{ $t('finds.exhibitorInfo') }}</div>
            <div class="l-h-2 p">{{ detail.introduction }}</div>

            <!-- <hr style="margin-top: 24px; margin-bottom: 15px; opacity: .2" /> -->
          </div>
        </div>

        <div class="bl-container" style="margin-top: 15px" v-if="false">
          <div class="bl-detail-foot-right">
            <div class="v-share">
              <AddThis publicId="ra-5ee1a595d2a288a7" />
              <span class="copy-btn" v-clipboard:copy="pageURL" v-clipboard:success="onCopy">{{ $t('Copy Link')
                }}</span>
            </div>
          </div>
        </div>


        <div class="bl-container hot-exhibits" v-if="homeHotExibits.length > 0 && detail.hotImage">
          <div class="v-title">{{ $t('Hosspot Image') }}</div>
          <swiper class="swiper" :options="swiperOption1" @slideChange="hideAllPopper">
            <swiper-slide v-for="item in homeHotExibits" :key="item.id">
              <div class="exibit-item">
                <div class="image-area">
                  <img class="exibit-item-image" :src="item.url" />

                  <el-popover ref="hot-popper" placement="right-end" popper-class="product-popper" width="280"
                    :visible-arrow="false" trigger="click" v-for="_item in item.hotImagePointList" :key="_item.id">
                    <div class="product-info">
                      <img :src="_item.productImgUrl.split(',')[0]" class="product-info-image">
                      <div class="info-content">
                        <div class="info-title">{{_item.productName}}</div>
                        <div class="info-description">{{_item.productIntro}}</div>
                        <div class="price">
                          <div>
                            <span v-if="_item.productPrice">￥{{_item.productPrice}}</span>
                          </div>
                          <div class="link" @click="pageDetail(_item, 'product')">{{$t('finds.enterDetail')}}</div>
                        </div>
                      </div>
                    </div>

                    <div class="product-pin" slot="reference"
                      :style="{ top: `${_item.cdnY}px`, left: `${_item.cdnX}px` }">
                      <div class="shadow"></div>
                      <div class="iconfont iconshangchuan"></div>
                    </div>
                  </el-popover>
                </div>
              </div>
            </swiper-slide>

            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </div>

    <div class="bl-find-list" v-if="detail">
      <div class="bl-container">
        <div class="v-title flex f-s-b">
          <div>
            {{ $t('finds.productList') }}
          </div>
          <template>
            <div class="search-exhibits-wrap">
              <div class="search-input-detail">
                <input v-model="searchKeywords" :placeholder="$t('productSearch')" size="mini" class="input"></input>
              </div>
              <div class="search-area-right" @click.stop="searchProductList" :loading="searchLoading">
                <span class="el-icon-search theme-color" />
                <span class="text">{{ $t('common.search') }}</span>
              </div>
              <!-- <el-button size="mini" type="primary" class="search-btn" :loading="searchLoading"
                @click.stop="searchProductList">{{
                $t('common.search')
                }}</el-button> -->
            </div>
          </template>
        </div>
        <div class="v-clearfix">
          <div class="product-type-menu" v-loading="menuLoading" v-if="false">
            <el-menu class="el-menu-vertical-product" :unique-opened="true" v-if="questionList[0].length > 0">
              <menu-question :index="0" :menu='questionList[0]' @menuClick="menuClick"></menu-question>
            </el-menu>
            <div v-else class="menuNoDate">{{$t('common.noData')}}</div>
          </div>
          <div class="product-list">
            <!-- <div class="prissionBox" v-if="newAndInviteStatus">
                <div class="title">{{scope == 2 ? $t('actorExhibitTip[1]') : $t('actorExhibitTip[0]')}}</div>
                <div class="todo">
                  <el-button type="primary" @click="exhibitsTypeList">{{scope == 2 ? $t('invite') : (isLogin ?  $t('login') : $t('registerText'))}}</el-button>
                </div>
                <div>
                  <div class="title">{{$t('lookMore')}}</div>
                </div>
              </div> -->
            <el-row class="ShangWai" :gutter="30" v-loading="searchLoading">
              <el-col class="ShangList" :xs="6" :sm="6" :md="6" v-for="(item, index) in dataList" :key="item.id">
                <ExhibitCard @callback="vExibitsCallback" :vData="item" :index="index" :liveStatus="false"
                  :slides="5" />
              </el-col>
            </el-row>

            <hNoData v-if="dataList.length == 0"></hNoData>
            <el-pagination v-if="dataList.length > 0" background :small="pageBox" @current-change="handleCurrentChange"
              :page-size="kQuery.pageRows" :current-page.sync="kQuery.pageNum" :page-count="pageCount"
              layout="total, prev, pager, next, jumper" :total="kQuery.total" class="bl-page">
            </el-pagination>
          </div>
        </div>
        <div class="prissionBox" v-if="newAndInviteStatus && $store.state.config.hideElement && false">
          <div class="todo">
            <div v-if="scope == 1 && !isCompleteExhibitionRegistration()">
              <el-button type="primary" class="no-radius"
                @click="exhibitsTypeList">{{$t('actorDetailRegister')}}</el-button>
            </div>
            <div class="inviteCode" v-if="scope == 2 && !detail.invite">
              <div class="invite1">
                <el-button type="primary" class="no-radius"
                  @click="exhibitsTypeList">{{$t('actorDetailInite')}}</el-button>
              </div>
              <div class="invite1">
                <span>{{$t('actorDetailInite2')}}</span>
                <div class="inviteInner">
                  <el-input size="small" maxlength="10" :placeholder="$t('Please enter the invitation code')"
                    v-model="inviteCode" />
                  <div class="font-size-12 margin-t-3">{{$t('Contact exhibitors via IM to get the invitation code')}}
                  </div>
                </div>
                <el-button type="primary" @click="inviteCodeFn" :loading='inviteCodeLoading' class="btnInvite"
                  size="small">{{$t('determine')}}</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-video v-if="detail && detail.advertsVideo" :isShow="isShowV" @callback="closeVideo"
      :src="detail.advertsVideo"></v-video>
    <ChatWithExhibitor @invite="submitInvite" :action="action" />

    <div class="fixedLeft" v-if="$store.state.config.hideElement">
      <div class="fixedLeftPerson fixedLeftDiv disabled" v-if="detail && detail.invite">
        <img :src="y" />
        <p class="fixedLeftP">{{ $t('finds.invited') }}</p>
      </div>
      <div class="fixedLeftPerson fixedLeftDiv" @click="inviteEvent2" v-else>
        <img :src="y" />
        <p class="fixedLeftP">{{ $t('invite') }}</p>
      </div>
      <div class="fixedLeftPerson fixedLeftDiv" @click="message2" v-if="detail">
        <img :src="m" />
        <p class="fixedLeftP">{{ $t('message') }}</p>
      </div>
      <div class="fixedLeftPerson fixedLeftDiv" @click="collectEvent2" v-if="detail">
        <img :src="c2" v-if="detail['collected']" />
        <img :src="c" v-else />
        <p class="fixedLeftP">{{ detail['collected'] ? $t('collect[1]') : $t('collect[0]') }}</p>
      </div>
      <div class="fixedLeftGoTop fixedLeftDiv" @click="goTopScroll()">
        <img :src="goTop" />
      </div>
    </div>

    <el-dialog title="Please enter your message" :visible.sync="dialogVisible" width="30%" :before-close="handleClose"
      v-loading="dialogLoading">
      <el-input type="textarea" v-model="messageContent" autocomplete="off"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose()">Cancel</el-button>
        <el-button type="primary" @click="cacMessage()">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { fetchExhibitorDetails, fetchExhibitorProduct} from '@/api/find'
import { getProductTags, getHotImageList, addContactPersonByInviteCode, addSuggest } from '@/api/index'
import { eventMixin } from '@/mixins/event.js'
import { inviteMixin } from '@/mixins/inviteEvent.js'
import hNoData from '@/components/hNoData'
import ExhibitCard from '@/components/card/ExhibitCard'
import AddThis from '@/components/AddThis'
import vVideo from '@/components/vVideo'
import vSwiper from '@/components/vSwiper'
import MenuQuestion from '@/components/menu/question'

import y from '@/assets/homeImages/7.png'
import m from '@/assets/homeImages/8.png'
import c from '@/assets/homeImages/9.png'
import c2 from '@/assets/homeImages/9-1.png'
import goTop from '@/assets/homeImages/goTop.png'

export default {
  name: 'findExhibitorDetail',
  mixins: [eventMixin, inviteMixin],
  components: {
    hNoData,
    AddThis,
    ExhibitCard,
    vVideo,
    vSwiper,
    MenuQuestion
  },
  props: ['id'],
  data() {
    return {
      dialogLoading: false, // 弹窗loading
      dialogVisible: false, // 留言弹窗
      messageContent: '', // 留言内容
      noShowData: ['introduction', 'enIntroduction', 'corporateName', 'name'],
      searchLoading: false,
      dataList: [],
      detail: null,
      detailsInfo: {},
      advertsImage: [],
      pageURL: window.location.href,
      isShowV: false,
      pageBox: false,
      firstImg: '',
      pageCount: 7,
      viewList: [],
      swiperOption: {
        imgW: '190px',
        imgH: '190px',
        slidesPerView: 6,
        list: [''],
        active: 0
      },
      y,
      m,
      c,
      c2,
      goTop: goTop,
      hList: [],
      searchKeywords: '',
      kQuery: {
        pageNum: 1,
        pageRows: 12,
        total: 0
      },
      /**
       * 0 全部可见
       * 1 预登记可见
       * 2 客户池可见
       */
      scope: 0,
      questionList: {
        '0': []
      },
      menuLoading: false,
      question: [],
      homeHotExibits: [],
      swiperOption1: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      inviteCode: '',
      inviteCodeLoading: false
    }
  },
  computed: {
    ...mapGetters(['exhibitorId', 'language','subjectType', 'info', 'isLogin']),
    pages: function() {
      if (this.query.total == 0) return 0
      let y = this.query.total % this.query.pageRows
      if (y == 0) {
        return this.query.total / this.query.pageRows
      } else {
        return parseInt(this.query.total / this.query.pageRows) + 1
      }
    },
    newAndInviteStatus: function () {
      console.log('this.detail--->',this.detail)
      return (this.detail && !this.detail.invite) || (!this.isCompleteExhibitionRegistration())
    }
  },
  mounted() {
    window.PC.$RangersEventDetail(this.id, {
      ...(this.$route.query || {})
    }, 'actor')
    if(document.body.clientWidth <= 750){
      this.pageCount = 2
      this.pageBox = true
    }
    this.pageInit()
  },
  methods: {
    // 打开弹窗
    handleShowDialog() {
      if (!this.isLoginFn()) return
      if (!this.todoPrission()) return
      this.messageContent = ''
      this.dialogVisible = true
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.messageContent = ''
    },
    // 提交留言
    cacMessage(item) {
      this.dialogLoading = true
      addSuggest({
        content: this.messageContent
      }).then((res) => {
        
        if (res.data.code == 1000) {
          this.$notify({
            title: 'Success',
            type: 'success'
          });
        }
        this.dialogLoading = false
        this.dialogVisible = false
      }).finally(() => {
        this.dialogLoading = false
        this.dialogVisible = false
      })
    },
    // 用户状态改版
    userChange() {
      this.scope = 0
      this.detail['invite'] = true
      this.getActorProductTags(0)
      this.searchProductList()
    },
    // 邀约码确认
    inviteCodeFn() {
      if (!this.inviteCode) return
      window.PC.$RangersEvent("exhibitordetails_invitationcode_confirmation_click", {
        exhibitor_id: this.detail.id
      })
      this.inviteCodeLoading = true
      addContactPersonByInviteCode({
        inviteCode: this.inviteCode,
        exhibitorId: this.detail.id,
        type: 2
      }).then(res => {
        if (res.data.data) {
          this.inviteCode = ''
          this.$funcs.scrollToY(0)
          this.userChange()
        }
      }).finally(() => {
        this.inviteCodeLoading = false
      })
      
    },
    // 产品中心 左侧菜单点击事件
    menuClick(key) {
      // 设置标签筛选条件
      if (key.length >= 3) {
        this.question = [{
          answerIds: [key[key.length - 1]],
          questionId: key[1]
        }]
        this.fetchProductList()
        return
      }
    },
    // 产品中心 邀约/注册 按钮
    exhibitsTypeList() {
      if (this.scope === 1) {
        window.PC.$RangersEvent("exhibitordetails_register_nowseemore_click", {
            exhibitor_id: this.id
        })
        // 预登记可见
        if (!this.isLogin) {
          // 未登录 去登录
          this.loginSource({source: true})
        } else {
          // 已登录 去完善信息
          this.loginSuccess(this.subjectType, {}, null, { secondInfo: true })
        }
      } else if (this.scope === 2) {
        // 仅客户池可见 (邀约)
        this.inviteEvent2('footer')
      }
    },
    radioChange() {
      this.searchKeywords = ''
      this.searchProductList()
    },
    goTopScroll() {
      cancelAnimationFrame(timer)
      var timer = requestAnimationFrame(function fn() {
        var oTop = document.body.scrollTop || document.documentElement.scrollTop
        if (oTop > 0) {
          scrollBy(0, -50)
          timer = requestAnimationFrame(fn)
        } else {
          cancelAnimationFrame(timer)
        }
      })
    },
    swiperList() {
      let _list = []
      if (this.detail.advertsVideo) {
        _list.push(this.detail.advertsVideoImage + ',' + this.detail.advertsVideo)
      }
      if (this.detail.advertsImage) {
        this.detail.advertsImage.split(',').forEach(element => {
          if (element) {
            _list.push(element)
            this.viewList.push(element)
          }
        })

        this.firstImg = _list[0].split(',')
      }

      if (_list.length != 0) {
        this.firstImg = _list[0].split(',')
      }

      this.swiperOption.list = _list
    },
    cb(type, param) {
      var obj = { type: type, data: param }
      if (typeof type !== 'string') {
        obj = type
      }
      if (type.type == 'swiper' && type.data && type.data.item) {
        this.swiperOption.active = type.data.index
        this.firstImg = type.data.item.split(',')
      }
      this.$emit('callback', obj)
    },
    // 展品卡片详情
    vExibitsCallback(eData) {
      let d = eData.data
      switch (eData.type) {
        case 'message':
          d = eData.data
          d.atrName = d.exhibitorName
          if (!d.exhibitorId) {
            d.exhibitorId = d.id
          }
          this.msgEventExh(d, null, 'products')
          break
        case 'invite':
          if (eData.data.invite) return
          this.inviteEventExh(eData.data, eData.index, 'products')
          break
        case 'details':
          this.pageDetail(eData.data, 'product')
          break
        case 'collect':
          this.collectEvent(
            {
              id: eData.data.collectionId,
              deleted: eData.data.collected,
              collectionSubjectType: 'PRODUCT',
              collectionSubjectId: eData.data.id
            },
            eData.index
          )
          break
        case 'live':
          this.live2(eData.data)
          break
      }
    },
    pageInit() {
      this.fetchDetail()

      this.getHotImages()
      this.getActorProductTags(0)
    },
    
    // 获取热点图
    getHotImages() {
      getHotImageList({
        exhibitorId: this.id,
        pageNum: 1,
        pageRows: 1000
      }).then(res => {
        this.homeHotExibits = res.data.data.list
      })
    },

    hideAllPopper() {
      this.$refs['hot-popper'].forEach(item => {
        item.doClose()
      })
    },

    // 获取展商下展品分类
    getActorProductTags() {
      this.menuLoading = true
      getProductTags({
        exhibitorId: this.id,
        showType: 'PRODUCT_DETAILS',
      }).then(res => {
        return res.data
      }).then(res => {
        if (res.data) {
          this.questionList[0] = res.data.questionList || []
        }
      }).finally(() => {
        this.menuLoading = false
      })
    },
    // 搜索展品
    searchProductList() {
      window.PC.$RangersEvent("exhibitordetails_filterBtn_click", {
        exhibitor_id: this.id
      }, () => {
        this.handleCurrentChange(1)
      })
    },
    // 页码 change
    handleCurrentChange(page) {
      this.kQuery.pageNum = page
      this.fetchProductList()
    },
    // 展商下产品中心
    fetchProductList() {
      this.searchLoading = true
      fetchExhibitorProduct({
        exhibitorId: this.id,
        showType: 'PRODUCT_LIST',
        verifyState: 'ONLINE',
        searchKeywords: this.searchKeywords,
        questionList: this.question,
        ...this.kQuery
      })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.data) {
            this.dataList = res.data.list || []
            this.kQuery.total = res.data.total
          }
        })
        .finally(() => {
          this.searchLoading = false
        })
    },
    // 更新收藏状态
    updateCollect(status, index) {
      this.dataList[index]['collected'] = status
    },
    // 更新邀约状态
    updateInvite(status, index) {
      this.dataList[index]['invite'] = status
      this.dataList.forEach(item => {
        item['invite'] = status
      })
      this.detail['invite'] = status
    },
    // 详情收藏
    collectEvent2() {
      this.collectEvent(
        {
          id: this.detail.collectionId,
          deleted: this.detail.collected,
          collectionSubjectType: 'ACTOR',
          collectionSubjectId: this.detail.id
        },
        status => {
          this.detail.collected = status
        }
      )
    },
    // 详情邀约
    inviteEvent2(moduleName) {
      this.detail.exhibitorId = this.detail.id
      this.detail.exhibitorName = this.detail.exhibitorName || this.detail.name || this.detail.atrName
      this.inviteEventExh(
        this.detail,
        status => {
          this.detail['invite'] = status
          this.dataList.forEach(item => {
            item['invite'] = status
          })

          this.userChange()
        },
        'exhibitors',
        moduleName
      )
    },
    // 详情消息
    message2() {
      this.detail.exhibitorId = this.detail.id
      this.detail.atrName = this.detail.atrName || this.detail.exhibitorName || this.detail.name
      this.msgEventExh(this.detail, () => {}, 'exhibitors')
    },
    // 详情直播
    live2(data) {
      this.liveEvent(data.liveId)
    },
    // 复制成功
    onCopy() {
      this.$notify({
        title: this.$t('tip.success'),
        message: this.$t('Copied'),
        type: 'success'
      })
    },
    // 获取详情
    fetchDetail() {
      const loading = this.$loading()
      fetchExhibitorDetails({
        id: this.id,
        showType: 'ACTOR_DETAILS'
      })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000 && res.data) {
            if (res.data.details) {
              res.data.details.forEach(item => {
                this.detailsInfo[item.keyword] = {
                  title: item.showValue.title,
                  content: item.showValue.content
                }
              })
            }
            this.detail = res.data
            if (this.detail.advertsImage) {
              this.advertsImage = this.detail.advertsImage.split(',')
            }
            if (!this.detail.logoImage) {
              this.detail.logoImage = this.defImage('product')
            }
            this.swiperList()
            this.detail.questionList = this.detail.questionList || []
            this.hList = this.detail.questionList.filter(item => {
              return ['2009', '20091'].indexOf(item.id) > -1
            })

            if (!this.isLogin ||!this.isCompleteExhibitionRegistration()) {
              this.scope = 1
            }
            //  else if (!this.detail.invite) {
            //   this.scope = 2
            // }

            this.fetchProductList()
          }
        })
        .finally(() => {
          loading.close()
        })
    },
    // 打开视频
    openVideo() {
      this.isShowV = true
    },
    // 关闭视频
    closeVideo() {
      this.isShowV = false
    }
  }
}
</script>

<style lang="stylus">
.el-menu-vertical-product {

  .menu-list {
    & > .el-submenu.is-active {
      & > .el-submenu__title {
        background: $color-main;
        color: $color-white;
      }
    }
  }

  .el-menu-item {
    height: 28px;
    line-height: 28px;
  }

  .level-0.el-menu-item {
    height: 44px;
    line-height: 44px;
  }

  .el-submenu__title {
    height: 44px;
    line-height: 44px;
    padding-right: 12px;
  }

  .level-0.is-active {
    background: $color-main;
    color: $color-white;
  }

  .el-submenu .el-menu-item {
    padding-right: 12px;
  }

  .el-submenu__icon-arrow {
    margin-top: -5px;
    right: 12px;
    transform: rotateZ(270deg);
  }

  .level-0 > .el-submenu__title,
  .level-0.el-menu-item {
      padding-left: 10px!important;
  }

  .level-1 > .el-submenu__title,
  .level-1.el-menu-item {
      padding-left: 20px!important;
  }

  .level-2 > .el-submenu__title,
  .level-2.el-menu-item {
      padding-left: 30px!important;
  }

  .level-3 > .el-submenu__title,
  .level-3.el-menu-item  {
      padding-left: 40px!important;
  }
}
</style>

<style lang="stylus" scoped>
.menuNoDate {
  padding: 5px;
  text-align: center;
  background: $color-white;
}

.search-exhibits-wrap {
  margin-top: 1px;
  padding-left: 14px;
  // margin: 0 auto;
  display: flex;
  align-items: center;
  background:red;
  width:480px;
  height:38px;
  line-height:38px;
  background: rgba(0,0,0,0.05);
  border-radius:8px;
  
  .search-input-detail {
    flex: 1;
    .input {
      display: inline-block;
      width: 100%;
      height: 50px;
      border: 0;
      outline: none;
      background: rgba(0, 0, 0, 0);
      font-size: 16px;

      &::placeholder {
        color: rgba(0, 0, 0, 0.25);
      }
    }
  }
  .search-area-right {
    flex-basis: 120px;
    cursor: pointer;
    user-select: none;
    text-align: center;

    .text {
      height: 22px;
      margin-left: 10px;
      text-align: center;
      color: $color-main;
      font-size: 16px;
    }
  }

  .search-btn {
    vertical-align: top;
  }
}

.product-type-menu {
  float: left;
  // width: 200px;
}

.product-list {
  // padding-left: 224px;
}


.bl-find-list{
  padding-bottom: 40px;
}

.bl-detail-block{
  background-color: transparent

  .bl-detail-left {
    width: 100%
    max-width: 100%
  }
}

.exhibitor-video-img{
  width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height 240px
  background-color: $color-black-10;
  overflow: hidden;
}

.exhibitor-images {
  img {
    margin-bottom: 25px;
    object-fit: contain;
    height: 220px;
    width: 100%;
    background-color: $color-black-10
  }
}

.v-exhibitor-data{
  margin: 12px  0;
  font-size: 14px;
  color: $color-black-65;

  *{
    line-height: 18px;
  }

  &>*{
    float: left;
    margin-right: 10px;
  }
}

.bl-detail-foot-left{
  float: left;
  overflow: hidden;
}

.bl-detail-foot-right {
  float: right;
}

.v-exhibitor-mess{
  &>div{
    margin-right: 24px;

    span{
      margin-left: 5px;
    }
  }
}

.v-exhibits-card {
  margin-bottom: 25px;
}

.v-person-m {
  float: left;

  & + .v-person-b {
    position relative
    padding-left: 116px;
  }
}

.v-person-view {
  position: absolute
  right: 0
  top: 4px

  span{
    display: block;
    margin-top: 5px;
    font-size: 14px;
    text-align: center;
  }

  i{
    font-size: 22px;
  }

}

.v-person-view2 {
    display: inline-block
    vertical-align: top;
    padding: 5px 0;
    line-height: 18px;

    * {
      line-height: 18px;
      
    }

    span{
      display: inline-block
      font-size: 14px;
      text-align: center;
      margin-left: 8px;
      vertical-align: top;
    }

    i{
      vertical-align: top;
      font-size: 16px;
    }
  }

.v-person-info2 {
  margin-top: 10px;
}

.v--video-img {
  margin-top: 24px;
  width: 100%;
  height: 560px;
  background-color: $color-black-10

  >>> img {
    object-fit: contain;
    height: 100%;
  }
}

.v-swiper {
  margin: 16px auto;
}

.v-title {
  margin: 24px 0 8px 0;
  height: 30px;
  font-size: 18px;
  font-weight:bold;
  color: $color-black-85
}

.v-color {
  font-size: 14px;
  margin-bottom: 15px;
  color: $color-black-65

  span:last-child{
    color: $color-black-85
    font-weight: bold
  }
}

.detail-questionTag {
  line-height: 16px;

  span{
    color: $color-black-65
  }

  label {
    padding: 4px 10px
    font-size: 14px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
}

.ques-label {
  display: inline-block;
  font-size: 14px;
  padding: 4px 10px;
  margin: 4px 10px 4px 0;
  line-height 16px;
}

.l-h-2{
  font-size:14px;
  color: $color-black-65;
  line-height: 24px;
}

.c65 {
  color: $color-black-65
}

.c85 {
  color: $color-black-85

  font-weight: bold;
}

.iconzhibo {
  margin-left: 0;

}

.color-live{
  display: inline-block;
  margin: 4px 0;
  line-height 24px;
}

.v-person-body{
  overflow: hidden

  .v-person-name{
    max-width: 86%;
    margin-right: 15px;
    float: left;
    color:$color-black-85;
  }

  .v-person-collect {
    float: none;
    display: inline-block;
    margin-right: 18px;
    padding: 5px 0;
    vertical-align: top;
    line-height: 18px;
    
    span {
      height: 18px;
    }
  }
}

.fixedLeft {
  top: 273px;
  bottom: auto;
  right: 50%;
  margin-right: -753px;
  z-index: 1000;
  display none
}
.hot-exhibits
  margin-top 30px
  .swiper-button-prev
    left 120px
    color $color-main
  .swiper-button-next
    right 120px
    color $color-main
 @media only screen and (max-width: 1510px ) {
    .fixedLeft {
      right: 10px;
      margin-right: 0;
    }
}
</style>
